import { render, staticRenderFns } from "./TeamsIndex.vue?vue&type=template&id=3f190ce8&scoped=true&"
import script from "./TeamsIndex.vue?vue&type=script&setup=true&lang=js&"
export * from "./TeamsIndex.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TeamsIndex.vue?vue&type=style&index=0&id=3f190ce8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f190ce8",
  null
  
)

export default component.exports